__turbopack_context__.v({
  "bar": "n35D3q_bar",
  "label": "n35D3q_label",
  "link": "n35D3q_link",
  "list": "n35D3q_list",
});
